<template>
  <div class="box" style="text-align:center;margin-top:100px;">
    <img src="@/assets/wait.png" alt="">
    微信授权登录中，请稍候...
  </div>
</template>

<script>
export default {
  name: "Callback",
  mounted() {
    this.wechatLogin();
  },
  methods: {
    async wechatLogin() {
      // 1. 获取微信回调回来的 code
      const code = window.location.href.split('?')[1].split('&')[0].split('=')[1]
      const arr = window.location.href.split('?')
      const path = decodeURIComponent(arr[arr.length-1])

      // 如果没有 code，返回首页
      if (!code) {
        this.$router.replace("/");
        return;
      }

      try {
        // 2. 把 code 发给后端，换取 openid / token / 用户信息
        const res = await this.$ajax.post("/api/auth/wechat/h5/login", {
          code: code,
        });

        if (res.data.code === 200) {
          const userInfo = res.data.data;
          sessionStorage.setItem('token',userInfo.token)
          // sessionStorage.setItem('userInfo',JSON.stringify(userInfo.userInfo))
          const currentRes = await this.$ajax.get('/api/user/current')
          if (currentRes.data.code == 200) {
            sessionStorage.setItem('userInfo', JSON.stringify(currentRes.data.data))
          }
          this.$router.replace(path);
        } else {
          this.$toast.error("登录失败：" + res.data.msg);
          this.$router.replace("/");
        }
      } catch (err) {
        console.error("登录异常", err);
        this.$toast.error("授权登录异常");
        this.$router.replace("/");
      }
    },
  },
};
</script>
<style scoped>
.box{
  text-align:center;
  margin-top:100px;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
img{
  margin-bottom: 20px;
  width: 50px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/callback.vue